import { render, staticRenderFns } from "./extensionDrawer.vue?vue&type=template&id=0ac687ea&scoped=true"
import script from "./extensionDrawer.vue?vue&type=script&lang=js"
export * from "./extensionDrawer.vue?vue&type=script&lang=js"
import style0 from "./extensionDrawer.vue?vue&type=style&index=0&id=0ac687ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac687ea",
  null
  
)

export default component.exports